module.exports = __webpack_public_path__ + "static/img/12.9d08396.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/8/zh/12.png
// module id = lWOR
// module chunks = 0